module.exports = __webpack_public_path__ + "img/X_onLight.697a3585.svg";